export default __webpack_public_path__ + "static/media/fusion-002.3579d9d9.svg";